import axiosInstance from './axiosInstance'
import errorHandler from '../transformers/axiosErrors'
import Cookies from '@/lib/cookies/cookies'
import NotifTransformer from './transformers/notification-transformer'
import { TOASTER } from '@/constants'
import { ApiResponse, Toaster } from '@/types'

export const getNextToaster = async (): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }

  try {
    const response = await axiosInstance().get('/toaster/next')

    resp.data = !hasSeenToaster(response.data)
      ? NotifTransformer.toasterToNotification(response.data)
      : null
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }

  return resp
}

export const hasSeenToaster = (toaster: Toaster): boolean => {
  if (!toaster.name) return true

  const name = `${TOASTER.COOKIE_PREFIX}${toaster.name}`
  return TOASTER.COOKIE_VALUE === Cookies.get(name)
}
